// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 179) return "3.67.3/styles/main.bundle.css";
	// return url for filenames based on template
	return "3.67.3/styles/" + "videojs" + ".chunk.css?" + "96dd924fb097e776b52c" + "";
};